import { combineReducers } from "redux";
// API
import userInfoDuck from "../ducks/UserInfo";
import sectionDuck from "../ducks/Section";
import languageDuck from "../ducks/Language";
import loadingDuck from "../ducks/Loading";
import FiltersDuck from "../ducks/Filters";
import OrdersDuck from "../ducks/Orders";
import EditableTableDuck from "../ducks/EditableTable";
import RiskAnalysisDuck from "../ducks/RiskAnalysis";
import ProjectManagementDuck from "../ducks/ProjectManagement";
import ProjectEstimateDuck from "../ducks/ProjectEstimate";
import billingPlanManagementDuck from "../ducks/BillingPlanManagement";
import TimesheetTableDuck from "../ducks/TimesheetTable";

const appReducer = combineReducers({
  userInfoDuck,
  sectionDuck,
  languageDuck,
  loadingDuck,
  FiltersDuck,
  OrdersDuck,
  EditableTableDuck,
  RiskAnalysisDuck,
  ProjectManagementDuck,
  billingPlanManagementDuck,
  ProjectEstimateDuck,
  TimesheetTableDuck,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    let iNeedLanguage = state.languageDuck;
    state = {};
    state.languageDuck = iNeedLanguage;
  }
  return appReducer(state, action);
};

export default rootReducer;
